<template>
  <NuxtLink
    :to="localePath({ name: 'guides-slug', params: { slug: guide.url } })"
    class="flex items-stretch rounded-2xl overflow-hidden border border-[#E0E0E0] bg-white hover:shadow-md transition-shadow cursor-pointer"
  >
    <div class="p-4 shrink-0 flex items-center">
      <NuxtImg
        :src="guide.photo.src"
        :alt="guide.name"
        class="w-24 h-24 object-contain"
      />
    </div>
    <div class="p-5 flex flex-col justify-center">
      <h2 class="text-base lg:text-lg font-bold text-[#222222] mb-2 leading-snug">{{ guide.name }}</h2>
      <p class="text-sm text-[#222222] leading-relaxed">{{ guide.description }}</p>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { GuideListItem } from '~/types'

const localePath = useLocalePath()

defineProps<{ guide: GuideListItem }>()
</script>
